import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { from, Observable, switchMap } from 'rxjs';
import { DeviceUuidService } from '../services/device-uuid.service';
import { ServerUrl } from '../services/server-url.service';
import { VersionService } from '../services/version.service';

/**
 * Insère le numéro de version tiré de config.xml dans les requêtes
 */
@Injectable()
export class ApiHeaderInjectorInterceptor implements HttpInterceptor {
  constructor(
    private readonly versionService: VersionService,
    private readonly serverUrl: ServerUrl,
    private readonly deviceUuidService: DeviceUuidService
  ) {}

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const serverApi = this.serverUrl.get();

    if (!request || !request.url || !/^http/.test(request.url) || !serverApi || !request.url.startsWith(serverApi)) {
      return next.handle(request);
    }
    const headers: Record<string, string> = {
      'application-version': this.versionService.getVersion(),
    };
    if (Capacitor.isNativePlatform()) {
      return from(this.deviceUuidService.fetch()).pipe(
        switchMap(uuid => {
          headers['device-uuid'] = uuid;

          return next.handle(request.clone({ setHeaders: headers }));
        })
      );
    } else {
      return next.handle(
        request.clone({
          setHeaders: headers,
        })
      );
    }
  }
}
